<script lang="ts">
    import type { Banner } from '@shared/types/types';

    let { tilelistSlot }: Banner = $props();
</script>

<div class={['reptile_banner', 'reptile_mas-list-slot']} data-tilelist-slot={tilelistSlot}></div>

<style lang="scss">
    .reptile_banner {
        grid-column: 1 / -1;

        &:empty {
            display: none;
        }
    }
</style>
